import React from 'react';
import { motion, useScroll, useSpring, useReducedMotion } from 'framer-motion';

/**
 * ScrollProgress — dünner Fortschrittsbalken ganz oben, der den
 * Lese-Fortschritt der Seite anzeigt. Respektiert prefers-reduced-motion
 * (wird dann statisch ohne Federung gezeichnet).
 */
const ScrollProgress = () => {
  const reduceMotion = useReducedMotion();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      style={reduceMotion ? { scaleX: scrollYProgress } : { scaleX }}
      className="fixed top-0 left-0 right-0 h-1 origin-left bg-gradient-to-r from-blue-500 via-blue-600 to-indigo-500 z-[60]"
      aria-hidden="true"
    />
  );
};

export default ScrollProgress;
